<template>
  <div>
    <t-form labelWidth="80px">
      <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />

      <t-form-item label="自动播放">
        <t-switch v-model="attribute.autoPlay" :label="['开', '关']" size="small" />
      </t-form-item>
      <!-- <t-form-item label="切换触发">
        <t-select v-model="attribute.trigger" placeholder="请选择触发切换方式" size="small">
          <t-option label="hover" value="hover" />
          <t-option label="click" value="click" />
        </t-select>
      </t-form-item> -->
      <t-form-item label="图片填充">
        <t-select v-model="attribute.fit" placeholder="请选择图片填充方式" size="small">
          <t-option label="fill" value="fill" />
          <t-option label="contain" value="contain" />
          <t-option label="cover" value="cover" />
          <t-option label="none" value="none" />
          <t-option label="scale-down" value="scale-down" />
        </t-select>
      </t-form-item>
      <t-form-item label="轮播滚筒条">
        <t-radio-group size="small" v-model="attribute.isShowNavbar">
          <t-radio-button :value="1">显示</t-radio-button>
          <t-radio-button :value="0">隐藏</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="轮播图片">
        <t-button size="small" @click="showGallery">添加图片</t-button>
      </t-form-item>
      <t-row :gutter="4">
        <t-col :span="6" v-for="(item, index) in attribute.imgUrls" :key="index" class="imgBlock">
          <t-image style="width: 100%; height: 100%;background: none" :src="fileUrl + item" fit="cover" />
          <div class="dleMask">
            <div style="width: 24px;margin: 40px auto;" @click="handleRemove(index)">
              <t-icon name="delete" />
            </div>
          </div>
        </t-col>
      </t-row>
      <t-form-item label="默认展示数量">
        <t-input-number v-model="attribute.defaultNumber" size="small" :min="1" :max="99999" />
      </t-form-item>
      <t-form-item label="图片间距">
        <t-input-number v-model="attribute.spaceBetween" size="small" :min="0" :max="99999" />
      </t-form-item>
      <t-form-item label="默认选中第几张">
        <t-input-number v-model="attribute.initialSlide" size="small" :min="1" :max="99999" />
      </t-form-item>
      <t-form-item label="选中边框颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.selecedBorderColor" size="small" />
      </t-form-item>

    </t-form>
    <gallery ref="gallery" @confirmCheck="confirmCheck" />
  </div>
</template>

<script>
import Gallery from "@/components/designer/gallery";
import { fileUrl } from "/env";
import CptData from '@/components/element/options/comp/cpt-data'

export default {
  name: "cpt-carousel-option",
  props: { attribute: Object, cptDataForm: Object, currentCpt: Object, refMap: Object },
  components: { Gallery, CptData },
  data() {
    return {
      fileUrl,
    }
  },
  methods: {
    showGallery() {
      this.$refs.gallery.opened();
    },
    confirmCheck(fileUrl) {
      this.attribute.imgUrls.push(fileUrl);
    },
    handleRemove(index) {
      this.attribute.imgUrls.splice(index, 1);
    },
  }
}
</script>

<style scoped>
.imgBlock {
  position: relative;
  height: 100px
}

.imgBlock:hover .dleMask {
  display: block;
  cursor: pointer
}

.dleMask {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background: #6667;
  color: #fff;
  font-size: 20px;
  display: none;
  z-index: 2
}
</style>
